exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".col4 {\n  position: relative;\n}\n\n.actions {\n  position: absolute;\n  top: 4px;\n  right: 20px;\n}\nform {\n  position: absolute;\n  top: 20px;\n  right: 0;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/hq/materials/manage-materials.component.css
// module id = ../../../../../src/app/hq/materials/manage-materials.component.css
// module chunks = main